import AccountingTabHtml        from './templates/tab.accounting.html';
import ManageChargifyHtml       from './admin-dashboard.manage-chargify.html';
import CompanyStatisticsTabHtml from './templates/tab.statistics.html';
import CompanyTypeTabHtml       from './templates/tab.company-type.html';
import CustomizationsTabHtml    from '../companies/company.customizations.html';
import ExportTabHtml            from './templates/tab.export.html';
import ManageDataTabHtml        from './templates/tab.manage-data.html';
import SupportTabHtml           from './templates/tab.support.html';
import UserManagementTabHtml    from './templates/tab.user-management.html';

export function CompanyManagementCtrl (
  $state,
  $stateParams,
  $scope,
  $translate,
  blockUI,
  company,
  AdminDashboard,
  companyApi,
  confirm,
  messages,
  sessionObjAPI,
  users,
  workshopAPI
) {
  $scope.block          = blockUI.instances.get('companyBlock');
  $scope.company        = company;
  $scope.current_user   = sessionObjAPI.user();
  $scope.loaded         = true;
  $scope.users          = users;

  $scope.adminDashboardApi = new AdminDashboard();
  $scope.Company           = companyApi;

  $scope.Company.setCompany($scope.company);

  $scope.allowPaymentUpdate = function () {
    $scope.block.start();

    $scope.adminDashboardApi.allowPaymentUpdate($scope.company)
    .then(() => {
      messages.show($translate.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.PAYMENT_UPDATE_RESET'), 'success');
    })
    .catch(err => {
      messages.error(err);
    })
    .finally(() => {
      $scope.block.stop();
    });
  };

  $scope.isActive = function (tab) {
    return tab === $stateParams.tab;
  };

  $scope.setPriceLookup = function () {
    workshopAPI.get('workshop_admin/set_price_lookup_on_products_for_company', $scope.company.id)
    .then(() => {
      messages.show($translate.instant('PRODUCT_SPACE.PRICE_LOOKUP_SET'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.toggleDealer = function () {
    confirm.generic($translate.instant('JS_SPACE.MESSAGES.SAVE_THIS_CHANGE'))
    .then(() => workshopAPI.get('workshop_admin/update_dealer_status', [ $scope.company.id, $scope.company.dealer ]))
    .then(() => sessionObjAPI.refresh())
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);

      $scope.company.dealer = !$scope.company.dealer;
    });
  };

  $scope.tabs = [
    {
      heading: $translate.instant('JS_SPACE.TABS.USER_MANAGEMENT'),
      content: UserManagementTabHtml,
      active : $scope.isActive('users')
    },
    {
      heading: $translate.instant('JS_SPACE.TABS.CHARGIFY'),
      content: ManageChargifyHtml,
      active : $scope.isActive('chargify')
    },
    {
      heading: $translate.instant('JS_SPACE.TABS.MANAGE_DATA'),
      content: ManageDataTabHtml,
      active : $scope.isActive('records')
    },
    {
      heading: $translate.instant('COMPANY_SPACE.TITLES.ACCOUNTING_INTEGRATIONS'),
      content: AccountingTabHtml,
      active : $scope.isActive('accounting')
    },
    {
      heading: $translate.instant('JS_SPACE.TABS.SUPPORT'),
      content: SupportTabHtml,
      active : $scope.isActive('support')
    },
    {
      heading: $translate.instant('GENERAL_SPACE.BUTTON.EXPORT'),
      content: ExportTabHtml,
      active : $scope.isActive('export')
    },
    {
      heading: $translate.instant('JS_SPACE.TABS.CUSTOMIZATIONS'),
      content: CustomizationsTabHtml,
      active : $scope.isActive('customizations')
    },
    {
      heading: $translate.instant('JS_SPACE.TABS.COMPANY_STATISTICS'),
      content: CompanyStatisticsTabHtml,
      active : $scope.isActive('stats')
    },
    {
      heading: $translate.instant('JS_SPACE.TABS.COMPANY_TYPE'),
      content: CompanyTypeTabHtml,
      active : $scope.isActive('type')
    }
  ];

  // need to reset company to session company
  $scope.$on('$destroy', () => companyApi.setCompany());
}